import { unwrap } from "@majourneys/api-client";
import { api } from "../../../lib/api";
import { apiBaseAbsolute } from "../../../lib/api-base";

export type MyReview = {
  id: string;
  rating: number;
  body: string;
  status: "pending" | "approved" | "rejected";
  rejectionReason: string | null;
  createdAt: string;
  activitySlug: string | null;
  activityTitle: string | null;
  activityImage: string | null;
};

export type SubmitReviewInput = {
  reservationId: string;
  rating: number;
  body: string;
};

/** Error thrown by reviewsApi.submit; carries the HTTP status for the UI. */
export class SubmitReviewError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = "SubmitReviewError";
  }
}

export const reviewsApi = {
  listMine: async (): Promise<MyReview[]> => {
    const res = unwrap(await api.me.reviews.get());
    return (res as MyReview[] | undefined) ?? [];
  },

  // POST /me/reviews expects multipart form-data (the schema allows optional
  // File images). We send the same shape the mobile app uses, minus the
  // manual content-type header — the browser sets the multipart boundary.
  submit: async (input: SubmitReviewInput): Promise<void> => {
    const form = new FormData();
    form.append("reservation_id", input.reservationId);
    form.append("rating", String(input.rating));
    form.append("body", input.body);

    const res = await fetch(`${apiBaseAbsolute()}/me/reviews`, {
      method: "POST",
      body: form,
      credentials: "include",
    });

    if (!res.ok) {
      let message = `Request failed (${res.status})`;
      try {
        const data = (await res.json()) as { message?: string };
        if (data?.message) message = data.message;
      } catch {
        // non-JSON body — keep the generic message
      }
      throw new SubmitReviewError(message, res.status);
    }
  },
};
